var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.59 3.577a.833.833 0 0 0-1.18 0L3.578 9.411a.833.833 0 0 0 1.179 1.178l4.41-4.41v9.654a.833.833 0 1 0 1.667 0V6.18l4.411 4.41a.833.833 0 0 0 1.179-1.178z"
  })));
};
export default SvgArrowUp;